import { Image, Box, SimpleGrid } from "@chakra-ui/react";

import "react-alice-carousel/lib/alice-carousel.css";

import achivement1 from "../projectimages/achivement1.jpg";
import achivement2 from "../projectimages/achivement2.jpg";
import achivement3 from "../projectimages/achivement3.jpg";
import achivement4 from "../projectimages/achivement4.jpg";

const data = [
  { image: achivement1 },
  { image: achivement2 },
  { image: achivement3 },
  { image: achivement4 },
];


const Achievements = () => {
  return (
    <Box mt={"25px"} w="80%" maxW={"1400px"}>
      <SimpleGrid
        p={5}
        spacing={{ base: 5, lg: 2 }}
        columns={{ base: 1, sm: 1, md: 2, lg: 4, xl: 4 }}
      >
        {data &&
          data.map((el) => (
            <Box
              boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
              overflow={"hidden"}
              w="95%"
              bg="white"
              borderRadius={10}
            >
              <Image userSelect={"-moz-none"} w="100%" src={el.image} />
            </Box>
          ))}
      </SimpleGrid>
    </Box>
  );
};

export default Achievements;
